<template lang="pug">
.loading-error.flex-fill.d-flex.flex-column.align-items-center.w-100.px-4.py-4
  .text-medium
    | {{ title }}
  button.btn.btn-secondary.px-3.mt-2(@click='handleReload')
    i.fa.fa-redo-alt.mr-2
    | {{ reloadMessage }}
</template>

<script>
export default {
  props: {
    title: {
      default: 'Loading Error',
    },
    reloadMessage: {
      default: 'ลองอีกครั้ง',
    },
  },
  methods: {
    handleReload() {
      this.$emit('reload');
    },
  },
};
</script>

<style lang="scss">
// .loading-error {}
</style>
